/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import NiceModal from '@ebay/nice-modal-react';
import { Toaster } from 'sonner';

// Providers
import QueryClientProvider from '@/providers/QueryClientProvider';
import RouterProvider from '@/providers/RouterProvider';
import CookieConsentProvider from '@/providers/CookieConsentProvider';

/* -------------------------------------------------------------------------- */
/*                                 Component                                  */
/* -------------------------------------------------------------------------- */
function App() {
  return (
    <QueryClientProvider>
      <NiceModal.Provider>
        <CookieConsentProvider>
          <RouterProvider />
          <Toaster position="bottom-right" richColors />
        </CookieConsentProvider>
      </NiceModal.Provider>
    </QueryClientProvider>
  );
}

export default App;
